import { ApprovalRequest } from '@abovo/shared-models';
import { MAT_DIALOG_TYPES } from '@abovo/shared-ui-components';
import { ApprovalRequestStore } from '@abovo/webvis-data-access';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ApprovalFeedbackDialogComponent } from '../components/approval-feedback-dialog/approval-feedback-dialog.component';

export function useApprovalFeedback() {
   const dialog = inject(MatDialog);
   const approvalRequestStore = inject(ApprovalRequestStore);

   return (data: ApprovalRequest, config: { approve?: boolean } = {}) => {
      const readonly = data.status?.slug !== 'pending';
      const feedbackDialog = dialog.open(ApprovalFeedbackDialogComponent, {
         ...MAT_DIALOG_TYPES.largest,
         disableClose: !readonly,
         data: { approvalRequest: data, config: { readonly, ...config } },
      });

      if (!readonly) {
         feedbackDialog.componentInstance.save.subscribe(async (result) => {
            const action = result.approved
               ? approvalRequestStore.approve(data.id, { comment: result.comment, override: result.override })
               : approvalRequestStore.reject(data.id, { comment: result.comment ?? '', override: result.override });

            action.then((success) => {
               if (success) {
                  feedbackDialog.close(true);
               }
               feedbackDialog.componentInstance.saving.set(false);
            });
         });
      }

      const afterClosed = firstValueFrom(feedbackDialog.afterClosed()).then((result) => !!result);

      return {
         dialog: feedbackDialog,
         afterClosed,
      };
   };
}
